/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Copilot_Remove_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to remove Compliance Copilot." |
*
* @param {Sub_Addons_Toast_Copilot_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_copilot_remove_error = /** @type {((inputs?: Sub_Addons_Toast_Copilot_Remove_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Copilot_Remove_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot konnte nicht entfernt werden.")
	return /** @type {LocalizedString} */ ("Failed to remove Compliance Copilot.")
});